import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { ITuple } from '@app/_models/tuple';
import { InventoryAsset } from '@app/_models/_DTOs/inventoryAsset';
import { InventoryAssetActionViewModel } from '@app/_models/_viewModels/inventoryAssetActionViewModel';

@Injectable({ providedIn: 'root' })
export class InventoryAssetService extends DataService<InventoryAsset> {
    constructor(http: HttpClient) {
        super(http, "api/inventory/assets")
    }

    getPageForUser(page: number, pageSize: number, sorts: string = "", filters: string = "") {
        var params = new HttpParams()
            .append('sorts', `${sorts}`)
            .append('filters', `${filters}`)
            .append('page', `${page}`)
            .append('pageSize', `${pageSize}`);
        return this.http.get<ITuple<InventoryAsset>>(`${environment.apiUrl}/${this.endpoint}/user`, { params });
    }

    signInventoryAsset(assetAction: InventoryAssetActionViewModel) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/signasset`, assetAction, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }
}